// The free-resources thank-you's opening sentence. Zero imports: node --test loads it directly.
export const FREE_SEAT_THANKS_DEFAULT = 'Check your inbox for your seat link.';

/** Command Centre's line when the Engine passed one, else the default (CC's feed may not carry it). */
export function freeSeatThanksLine(freeSeat: { thanks_line?: string | null }): string {
  return freeSeat.thanks_line?.trim() || FREE_SEAT_THANKS_DEFAULT;
}
